import axios from 'axios';
import { getAccessToken } from '../../utils/jwt';
import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

axiosInstance.interceptors.request.use((config) => {
  config.headers = {
    Authorization: `Bearer ${getAccessToken()}`,
  };
  return config;
});

const searchFeedback = async ({
  belongsTo,
  dateCreatedFrom,
  dateCreatedTo,
  projects,
  clientIds,
  locationIds,
  sourceSystemIds,
  divisionIds,
  pageSize,
  page,
  sortBy,
}) => {
  const queryParams = [];

  if (belongsTo) {
    queryParams.push(`belongsTo=${encodeURIComponent(belongsTo)}`);
  }

  if (dateCreatedFrom) {
    queryParams.push(`dateCreatedFrom=${encodeURIComponent(dateCreatedFrom)}`);
  }

  if (dateCreatedTo) {
    queryParams.push(`dateCreatedTo=${encodeURIComponent(dateCreatedTo)}`);
  }

  if (Array.isArray(projects) && projects.length > 0) {
    queryParams.push(`projects=${projects.map((x) => encodeURIComponent(x)).join(',')}`);
  }

  if (Array.isArray(clientIds) && clientIds.length > 0) {
    queryParams.push(`clientIds=${clientIds.join(',')}`);
  }

  if (Array.isArray(locationIds) && locationIds.length > 0) {
    queryParams.push(`locationIds=${locationIds.join(',')}`);
  }

  if (Array.isArray(divisionIds) && divisionIds.length > 0) {
    queryParams.push(`divisionIds=${divisionIds.join(',')}`);
  }

  if (Array.isArray(sourceSystemIds) && sourceSystemIds.length > 0) {
    queryParams.push(`sourceSystemIds=${sourceSystemIds.join(',')}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(`/feedback/all/by?${queryParams.join('&')}`);
    // const response = await axiosInstance.get('/portalfeedback/all');
    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const addNewComment = async ({
  user,
  sourceSystemID,
  recordID,
  belongsTo,
  comment,
  rating,
  rating2,
  rating3,
  active,
  flags,
  createdOn,
  createdBy
}) => {
  try {
    const res = await axiosInstance.post('/Feedback/insert', {
      Username: user,
      SourceSystemID: sourceSystemID,
      RecordID: recordID,
      BelongsTo: belongsTo,
      Comment: comment,
      Rating: rating,
      Rating2: rating2,
      Rating3: rating3,
      Active: active,
      Flags: flags,
      CreatedOn: createdOn,
      CreatedBy: createdBy
    });
    return res.data;
  } catch (e) {
    throw new Error('Error PostFeedback has some error');
  }
};

const feedbackApi = {
  searchFeedback,
  addNewComment
};

export default feedbackApi;
